export default {"src":"/_next/static/media/watersport.ca0bf927.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};